import { uslogo } from "../../assets/images/images";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";
import Topbar from "../../components/Topbar/Topbar";
import { useTranslation } from 'react-i18next'; // Import the translation hook
import "./us.css";

import React from "react";

export default function Us() {
  const { t } = useTranslation(); // Initialize the translation hook

  return (
    <div className="Page_us">
      <Topbar />
      <Navbar />
      <div className="main">
        <div className="container">
          <div className="left_part">
            <p className="title">{t("us.title")}</p>
            <p className="parg">{t("us.paragraph1")}</p>
            <p className="parg">{t("us.paragraph2")}</p>
            <p className="parg">{t("us.paragraph3")}</p>
            <p className="parg">{t("us.paragraph4")}</p>
            <p className="parg">{t("us.paragraph5")}</p>
            <p className="parg">{t("us.paragraph6")}</p>
          </div>
          <div className="right_part">
            <img src={uslogo} style={{width:"80%"}} alt="logo" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}